import WanderuErrorBoundary from './components/WanderuErrorBoundary';

export default WanderuErrorBoundary;
